import React from "react";
import { Check, Wifi, GraduationCap } from "lucide-react";
import { useSite } from "../contexts/SiteContext";
import { defaultContent } from "../data/defaultContent";

const PLATFORM_IMG = {
  big: "/images/platform.jpg",
  online: "/images/online-learning.jpg",
  cafe: "/images/elementary.jpg",
};

const Platform = () => {
  const { content } = useSite();
  const p = content.platform || defaultContent.platform;
  return (
    <section style={{ padding: "90px 24px" }}>
      <div style={{ maxWidth: 1240, margin: "0 auto", display: "grid", gridTemplateColumns: "1fr 1.1fr", gap: 56, alignItems: "center" }} className="plat-grid">
        <div className="fade-in">
          <span className="pill" style={{ marginBottom: 16 }}>
            <span style={{ width: 18, height: 1, background: "#1A1352" }} /> {p.kicker}
          </span>
          <h2 className="h-display" style={{ fontSize: "clamp(32px, 4.4vw, 56px)", margin: "12px 0 18px" }}>
            {p.titleLine1}<br />
            {p.titleLine2Prefix}<span className="text-grad-purple">{p.titleLine2Highlight}</span>{p.titleLine2Suffix}
          </h2>
          <p style={{ color: "#5F5A72", fontSize: 16, lineHeight: 1.6, marginBottom: 22 }}>{p.subtitle}</p>
          <ul style={{ listStyle: "none", padding: 0, display: "flex", flexDirection: "column", gap: 12 }}>
            {(p.bullets || []).map((t) => (
              <li key={t} style={{ display: "flex", alignItems: "center", gap: 12, color: "#1A1352", fontSize: 15 }}>
                <span style={{ width: 24, height: 24, borderRadius: 8, background: "rgba(84,70,234,0.12)", display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <Check size={14} color="#5446EA" strokeWidth={3} />
                </span>
                {t}
              </li>
            ))}
          </ul>
        </div>

        <div className="fade-in" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
          <div className="img-zoom-wrap card-soft" style={{ aspectRatio: "1/1", borderRadius: 24, gridRow: "span 2" }}>
            <img src={PLATFORM_IMG.big} alt="Plataforma" className="img-zoom" />
          </div>
          <div className="img-zoom-wrap card-soft" style={{ aspectRatio: "4/3", borderRadius: 24, position: "relative" }}>
            <img src={PLATFORM_IMG.online} alt="Aprendizaje" className="img-zoom" />
            <div style={{ position: "absolute", bottom: 12, left: 12, background: "rgba(84,70,234,0.95)", color: "#fff", padding: "10px 14px", borderRadius: 14, display: "flex", alignItems: "center", gap: 10 }}>
              <Wifi size={16} />
              <div style={{ lineHeight: 1.15 }}>
                <div style={{ fontWeight: 700, fontSize: 14 }}>24/7</div>
                <div style={{ fontSize: 11, opacity: 0.9 }}>Acceso desde cualquier dispositivo</div>
              </div>
            </div>
          </div>
          <div className="img-zoom-wrap card-soft" style={{ aspectRatio: "4/3", borderRadius: 24, position: "relative" }}>
            <img src={PLATFORM_IMG.cafe} alt="Estudiando" className="img-zoom" />
            <div style={{ position: "absolute", bottom: 12, left: 12, background: "rgba(255,255,255,0.96)", color: "#1A1352", padding: "10px 14px", borderRadius: 14, display: "flex", alignItems: "center", gap: 10 }}>
              <GraduationCap size={16} color="#FF4F1A" />
              <div style={{ lineHeight: 1.15 }}>
                <div style={{ fontWeight: 700, fontSize: 14 }}>Tutor 1:1</div>
                <div style={{ fontSize: 11, color: "#5F5A72" }}>Feedback humano y específico</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>{`@media (max-width: 900px){.plat-grid{grid-template-columns:1fr !important;gap:30px !important;}}`}</style>
    </section>
  );
};

export default Platform;
